import store from './index';
import ApiService from '@/services/ApiService';
import SocketService from '../services/SocketService';
import UtilsService from '../services/UtilsService';
import MessageQueries from '../queries/message.queries';
import MessageService from '../services/MessageService';
import { Message } from '../models';

export interface MessageState {
  messages: Message[];
  messageSubscribeId: number;
  loading: boolean;
}

export const MessageModule = {
  state: {
    messages: [],
    messageSubscribe: 0,
    loading: false,
  },
  mutations: {
    setMessages(state: MessageState, messages: Message[]) {
      state.messages = messages;
    },
    setMessageSubscribe(state: MessageState, subscribe: number) {
      state.messageSubscribeId = subscribe;
    },
    onMessageCreate(state: MessageState, message: Message) {
      state.messages.push(message);
    },
    setMessageLoading(state: MessageState, loading: boolean) {
      state.loading = loading;
    },
  },
  actions: {
    unsubscribeMessages() {
      if (store.state.message.messageSubscribeId) {
        SocketService.unsubscribe(store.state.message.messageSubscribeId);
      }
    },
    async loadMessages(context: any, chatId: string) {
      const query = MessageQueries.getAllByChat(chatId);
      if (!query) { return; }
      context.dispatch('unsubscribeMessages');
      context.commit('setMessageLoading', true);
      const messages = await ApiService.get(UtilsService.buildFullPath(query)).catch(() => {
        // @TODO open alert
      });
      context.commit('setMessageLoading', false);
      context.commit('setMessages', messages.results);
      const sub = await SocketService.subscribe({
        query: { where: query.where, className: query.className },
        events: {
          create: 'onMessageCreate',
        },
      });
      context.commit('setMessageSubscribe', sub);
    },
    async sendMessage(context: any, payload: any): Promise<any> {
      const chatId = store.state.chat.selectedChat.objectId;
      const currentUserId = store.state.auth.currentUser.objectId;

      const message = MessageQueries.create(chatId as string, currentUserId, payload.message, payload.platform);
      return MessageService.createMessage(message);
    },
    async sendSMSMessage(context: any, payload: any): Promise<any> {
      return MessageService.createSMSMessage(payload);
    },
  },
};
